export default {
  m0: {
    margin: 0
  },
  mb10: {
    marginBottom: 10
  },
  centerItems: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '50%',
    justifyContent: 'center'
  },
  alignWithTitleSection: {
    marginTop: -47,
    display: 'flex'
  }
}
